module.exports = __webpack_public_path__ + "static/img/icon_pa.f43e4e84.png";